export default function Back({ children, ...buttonProps }) {
  return (
    <button type='button' {...buttonProps}>
      &lt; {children}
      <style jsx>{`
        button {
          background: none;
          transition: opacity 0.2s;
          color: var(--secondary-text-color);
          font-weight: 700;

          &:active {
            opacity: 0.7;
          }
        }
      `}</style>
      <style jsx>{`
        @media (max-width: 1024px) {
          button {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </button>
  )
}
